<template>
  <v-row>
    <v-col cols="12">
      <BaseBlock title="Votre formation continue">
        <p class="text-sm-left body-2 font-italic">
          Les informations à renseigner ne le sont qu’à titre indicatif et ne
          sauraient préjuger de l’avis qui sera émis par la commission régionale
          d’agrément.
        </p>
        <v-form ref="form" v-model="valid" lazy-validation>
          <v-row>
            <v-col cols="12" md="6">
              <span class="subtitle-1 text-left font-weight-bold">
                &#187; Développement professionnel continu (DPC) sur les 5
                dernières années :
              </span>
              <v-text-field
                v-for="(formationDPC, index) in formationsDPC"
                :key="index"
                v-model="formationsDPC[index]"
                :label="getFormationDPCLabel(index)"
              ></v-text-field>
              <v-btn
                @click="formationsDPC.push(null)"
                :disabled="formationsDPC.length > 4"
                >+ ajouter une formation DPC</v-btn
              >
              <v-row>
                <v-col cols="12" md="6"></v-col>
              </v-row>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="6">
              <span class="subtitle-1 text-left">
                &#187; Justificatifs des 5 dernières années à fournir
                impérativement (Synthèse ANDPC) :
              </span>
              <v-simple-table>
                <template v-slot:default>
                  <tbody>
                    <tr
                      v-for="(fichier,
                      index) in justificatifsFormationsFichiers"
                      :key="index"
                    >
                      <td>{{ fichier.name }}</td>
                      <td>
                        <v-checkbox
                          @change="suppressionFichier($event, fichier.id)"
                          label="supprimer ce justificatif"
                          class="pa-1 mt-0"
                          hide-details
                        >
                        </v-checkbox>
                      </td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
              <v-file-input
                v-for="(justificatif, index) in justificatifsFormations"
                :key="index"
                v-model="justificatifsFormations[index]"
                truncate-length="15"
                :rules="justificatifRules"
                show-size
              ></v-file-input>
              <v-btn
                v-if="erreurJustificatif"
                @click="justificatifsFormations.push(null)"
                color="error"
                >+ ajouter un justificatif</v-btn
              >
              <v-btn v-else @click="justificatifsFormations.push(null)"
                >+ ajouter un justificatif</v-btn
              >

              <div
                class="v-messages theme--light error--text"
                role="alert"
                v-if="erreurJustificatif"
              >
                Ce champ est requis
              </div>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="8">
              <p>
                <span class="font-weight-bold"
                  >&#187; Suite à la loi HPST du 21 juillet 2009 :</span
                >
                Obligation de participer au cours de chaque année civile, à un
                programme de DPC collectif annuel ou pluriannuel mis en œuvre
                par un organisme de DPC enregistré (décret 2011-2118 du 30
                décembre 2011).<br />
                - <u>Depuis le 1er janvier 2017</u>, tout pharmacien doit
                justifier, pour une période de 3 ans, de son engagement dans une
                démarche de DPC comportant des actions de formation continue,
                d’analyse, d’évaluation et d’amélioration de ses pratiques et de
                gestion des risques (article 114 de la LOI n° 2016-41 du 26
                janvier 2016 de modernisation de notre système de santé).
              </p>
              <v-row>
                <v-col cols="12" md="6">
                  <span class="subtitle-1 text-left">
                    &Ecirc;tes-vous en conformité avec cette obligation ?
                  </span></v-col
                >
                <v-col cols="12" md="2">
                  <v-radio-group
                    v-model="dossier.hpstConformite"
                    row
                    required
                    :rules="radioRules"
                  >
                    <v-radio
                      label="oui"
                      name="agrementEcheance"
                      v-bind:value="true"
                      required
                    ></v-radio>
                    <v-radio
                      label="non"
                      name="agrementEcheance"
                      v-bind:value="false"
                      required
                    ></v-radio>
                  </v-radio-group>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="6">
              <span class="subtitle-1 text-left font-weight-bold">
                &#187; Autres formations suivies au cours des 3 dernières années
                :
              </span>
              <v-text-field
                v-for="(autreFormation, index) in autresFormations"
                :key="index"
                v-model="autresFormations[index]"
                :label="getAutresFormationsLabel(index)"
              ></v-text-field>
              <v-btn
                @click="autresFormations.push(null)"
                :disabled="autresFormations.length > 2"
                >+ ajouter une formation</v-btn
              >
              <v-row>
                <v-col cols="12" md="6"></v-col>
              </v-row>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="8">
              <span class="subtitle-1 text-left font-weight-bold">
                &#187; Missionner un pharmacien adjoint :
              </span>
              <span>
                Vous avez la possibilité de missionner, à chaque stage, un
                pharmacien adjoint pour participer à la formation des
                stagiaires. Cette mission est à renouveler à chaque stage.
              </span>
              <v-row>
                <v-col cols="12" md="6">
                  <p class="subtitle-1 text-left">
                    Envisagez-vous cette éventualité ?
                  </p></v-col
                >
                <v-col cols="12" md="3">
                  <v-radio-group
                    v-model="dossier.adjointMission"
                    row
                    required
                    :rules="radioRules"
                  >
                    <v-radio
                      label="oui"
                      name="adjointMission"
                      value="oui"
                      required
                    ></v-radio>
                    <v-radio
                      label="non"
                      name="adjointMission"
                      value="non"
                      required
                    ></v-radio>
                    <v-radio
                      label="ne sais pas"
                      name="adjointMission"
                      value="ne sais pas"
                      required
                    ></v-radio>
                  </v-radio-group>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="5" />
            <v-col cols="1">
              <v-btn
                color="blue"
                class="mr-4 white--text"
                @click="submit"
                :disabled="!valid"
                >Enregistrer et passer à l'étape suivante
                <v-icon>navigate_next</v-icon></v-btn
              >
            </v-col>
          </v-row>
        </v-form>
      </BaseBlock>
    </v-col>
  </v-row>
</template>

<script>
import BaseBlock from "@/components/base/BaseBlock";
import ApiDossierRepository from "@/repositories/ApiDossierRepository";

export default {
  name: "Partie4",
  props: ["dossier"],
  components: { BaseBlock },
  data: () => ({
    valid: true,
    formationsDPC: [],
    autresFormations: [],
    justificatifsFormations: [],
    justificatifsASupprimer: [],
    erreurJustificatif: false,
    textRules: [v => !!v || "Ce champ est requis"],
    radioRules: [v => v !== null || "Ce champ est requis"],
    justificatifRules: [
      value =>
        !value ||
        value.size < 10000000 ||
        "La taille du fichier dépasse la limite autorisée (10Mo)"
    ]
  }),
  computed: {
    justificatifsFormationsFichiers() {
      if (this.dossier.formationsJustificatifs) {
        return this.dossier.justificatifs.filter(
          f => this.dossier.formationsJustificatifs.indexOf(f.id) > -1
        );
      } else {
        return [];
      }
    }
  },
  created() {
    this.formationsDPC = JSON.parse(this.dossier.formationsDPC);
    if (!this.formationsDPC) this.formationsDPC = [null];
    this.autresFormations = JSON.parse(this.dossier.autresFormations);
    if (!this.autresFormations) this.autresFormations = [null];
  },
  methods: {
    onLoading(bool) {
      this.$store.dispatch("setFormLoading", bool);
    },
    suppressionFichier(event, id) {
      if (event) {
        this.justificatifsASupprimer.push(id);
      } else {
        this.justificatifsASupprimer = this.justificatifsASupprimer.filter(
          f => f != id
        );
      }
    },
    getFormationDPCLabel(index) {
      let part = index + 1;
      return "Formation DPC (" + part + "/5)";
    },
    getAutresFormationsLabel(index) {
      let part = index + 1;
      return "Formation (" + part + "/3)";
    },
    async submit() {
      if (this.$refs.form.validate()) {
        this.dossier.formationsDPC = JSON.stringify(this.formationsDPC);
        this.dossier.autresFormations = JSON.stringify(this.autresFormations);

        // upload fichiers
        let idsNewJustificatifs = [];
        // si des champs d'upload sont actifs
        if (this.justificatifsFormations.length > 0) {
          this.onLoading(true);
          // pour chaque champ d'upload
          for (let file of this.justificatifsFormations) {
            // si le champ contient un fichier
            if (file) {
              // on  envoie le fichier
              const response = await ApiDossierRepository.addJustificatif(
                this.dossier.id,
                this.dossier.codeAcces,
                file
              );
              // on ajoute son id dans la liste des id des nouveaux fichiers
              idsNewJustificatifs.push(response.id);

              // et le nouveau fichier dans la liste des justificatifs du dossier
              this.dossier.justificatifs.push(response);
            }
          }
          this.onLoading(false);
        }
        // le champ cible reçoit la liste des nouveaux id, mergée à celle déjà existante
        this.dossier.formationsJustificatifs = JSON.stringify(
          this.$lodash.concat(
            JSON.parse(this.dossier.formationsJustificatifs),
            idsNewJustificatifs
          )
        );
        let justificatifsApresSuppr = this.dossier.formationsJustificatifs;
        for (let id of this.justificatifsASupprimer) {
          let formations = JSON.parse(this.dossier.formationsJustificatifs);
          let index = formations.indexOf(id);
          formations.splice(index, 1);
          justificatifsApresSuppr = JSON.stringify(formations);
        }
        idsNewJustificatifs = [];

        // contrôle sur la présence de justificatifs
        this.erreurJustificatif = false;
        if (!justificatifsApresSuppr) {
          this.erreurJustificatif = true;
        } else if (JSON.parse(justificatifsApresSuppr).length == 0) {
          this.erreurJustificatif = true;
        } else {
          let justificatifOK = false;
          for (let justificatif of JSON.parse(justificatifsApresSuppr)) {
            if (justificatif != null) {
              justificatifOK = true;
            }
          }
          this.erreurJustificatif = !justificatifOK;
        }
        if (!this.erreurJustificatif) {
          this.dossier.formationsJustificatifs = justificatifsApresSuppr;
          this.$emit("save");
          this.$emit("nextPart");
        }
      }
    }
  }
};
</script>
